const axios = require('axios');

module.exports = function injectAxiosExtension(extension) {
  const origin = axios.create;
  axios.create = function wrappedCreate(config) {
    const result = origin(config);
    extension(result);
    return result;
  };
  extension(axios);
};
